import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from 'app/services/apis.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-player',
  templateUrl: './edit-player.component.html',
  styleUrls: ['./edit-player.component.scss']
})
export class EditPlayerComponent implements OnInit {
  player: any = {
    image: '',
    fullName: '',
    age: '',
    country: '',
    city: '',
    phoneNumber: '',
    nationality: ''
  };
  playerForm: FormGroup;
  // playerId: number;
  playerData: any;
  playerImage: string = ''; // Holds image preview
  selectedFile: File | null = null;
  userForm: FormGroup;
  playerId: number | null = null;
  nationalities: any[] = [];
  countries: any[] = [];
  constructor(private route: ActivatedRoute,
    private apisService : ApisService,
    private router: Router,
    private fb: FormBuilder, 
    private toastr : ToastrService
  ) {}

   ngOnInit(): void {
    this.initializeForm();
    this.loadNationalities();
    this.loadCountries();
    // Get player ID from route
    this.route.params.subscribe(params => {
      this.playerId = params['id'];
      if (this.playerId) {
        this.loadPlayerData();
      } else {
        console.error('Player ID is missing from the route');
      }
    });


  }
 
  initializeForm(): void {
    this.playerForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      bio: [''],
      nationality: ['', Validators.required],
      country: ['', Validators.required],
      city: ['', Validators.required],
      gender: ['', Validators.required],
      weight: ['', Validators.required],
      height: ['', Validators.required],
      strongFoot: ['', Validators.required],
      primaryPosition: ['', Validators.required],
      otherPosition: [''],
      nationalityId: ['', Validators.required], // Store only ID
      countryId: ['', Validators.required] ,
      media : ['']
    });
  }

  // Fetch Nationalities from API
loadNationalities() {
  this.apisService.getCountries().subscribe((response) => {
      if (response && response.data) {
          this.nationalities = response.data.items;
      }
  });
}

// Fetch Countries from API
loadCountries() {
  this.apisService.getCountries().subscribe((response) => {
      if (response && response.data) {
          this.countries = response.data.items;
      }
  });
}

  loadPlayerData() {
    if (!this.playerId) return;
  
    this.apisService.getPlayerById(this.playerId).subscribe(
      (response) => {
        if (response && response.data) {
          this.playerForm.patchValue({
            firstName: response.data.firstName || '',
            lastName: response.data.lastName || '',
            bio: response.data.bio || '',

             // ✅ Store both ID and name for nationality
             nationalityId: response.data.nationality?.id || '', 
            nationality: response.data.nationality.name || '',

              // ✅ Store both ID and name for country
              countryId: response.data.country?.id || '',
            country: response.data.country?.name || '', // Extract country name
            city: response.data.city || '',
            // gender: response.data.gender || '',
            gender: response.data.gender === 'MALE' ? 'MALE' : 'FEMALE', // ✅ Ensure correct value

            
            weight: response.data.weight || '',
            height: response.data.height || '',
            strongFoot: response.data.strongFoot || '',
            primaryPosition: response.data.primaryPosition || '',
            otherPosition: response.data.otherPosition || ''
          });
 // Set player image using environment variable
 this.playerImage = response.data.media?.url  
 ? `${environment.mediaStagingFetching}/${response.data.media.url}`
 : 'assets/images/goalngo/profile.svg'; // Default image if no URL

        }
      },
      (error) => {
        console.error('Error fetching player data:', error);
      }
    );
  }
  

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.playerImage = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  updatePlayer() {
    const updatedData: any = {
      firstName: this.playerForm.value.firstName,
      lastName: this.playerForm.value.lastName,
      bio: this.playerForm.value.bio,
      gender: this.playerForm.value.gender.toUpperCase(),
      city: this.playerForm.value.city,
      nationalityId: this.playerForm.value.nationalityId || '',
      countryId: this.playerForm.value.countryId || '' ,
    };
  
    if (this.selectedFile) {
      // Step 1: Get presigned URL
      const mediaForm = {
        files: [{ name: this.selectedFile.name }]
      };
  
      this.apisService.presignedUrl(mediaForm).subscribe({
        next: (res) => {
          const mediaUrl = res.data?.[0]?.url;
          const mediaName = res.data?.[0]?.name;
  

          this.apisService.MediaUpload(mediaUrl, this.selectedFile).subscribe({
            next: () => {
              
              updatedData.url = mediaName
              this.sendJsonRequest(updatedData);
            },
            error: () => {
              this.toastr.error('Media upload failed');
            }
          });
        },
        error: () => {
          this.toastr.error('Failed to get media URL');
        }
      });
    } else {
      // No new image selected, use existing image name
      const cdnPrefix = `${environment.mediaStagingFetching}/`;
      const existingUrl = this.playerImage.startsWith(cdnPrefix)
        ? this.playerImage.replace(cdnPrefix, '')
        : this.playerImage;
  
      updatedData.url = existingUrl;
      this.sendJsonRequest(updatedData);
    }
  }
  
  private sendJsonRequest(payload: any) {
    this.apisService.updatePlayer(this.playerId, payload).subscribe({
      next: () => {
        console.log(payload);
        this.toastr.success('Player updated successfully'); 
        setTimeout(() => {
          this.router.navigate(['/users-list']);
        } , 2000);
        
      },
      error: (error) => {
        this.toastr.error('Error updating player');
      }
    });
  }


  
  
  
}